import { Layout, Text } from '@taxdown/piccolo-web';
import styled from 'styled-components';

export const TotalToRecover = styled(Layout.Wrap)`
  background: ${({ theme: { system } }) =>
    system.background.fds_sys_color_background_success_strong};
`;

export const TextWarning = styled(Text)`
  text-decoration: line-through;
`;
